import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from '../../dialog';
import { CommonModule as NimbusCommonModule } from '../../common/common.module';
import { SharePasswordComponent } from './share-password.component';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    DialogModule,
    FormsModule,
    NimbusCommonModule,
    BrowserModule
  ],
  declarations: [
    SharePasswordComponent
  ],
  providers: [],
  exports: [
    SharePasswordComponent
  ]
})
export class SharePasswordModule { }
